export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "Logga in",
    "login.form.hint.user": "Inloggning",
    "login.form.hint.password": "Lösenord",
    "login.form.checkbox.remember-me": "Kom ihåg mig",
    "login.form.button.sign-in": "Logga in",
    "login.form.message.invalid-user-credentials": "Inloggning eller lösenord är felaktigt",
    "login.form.message.account-temporarily-locked": "Ditt konto har låsts tillfälligt, kom tillbaka om 5 minuter",
    "login.form.message.user-required": "Ange inloggning",
    "login.form.message.password-required": "Ange ett lösenord",
    "login.form.button.forgot-password": "Glömt lösenordet?",
    "error.mfa-required.title": "Ställ in 2FA",
    "error.mfa-required.message1": "Tvåfaktorsautentisering (2FA) krävs för att skydda ditt konto.",
    "error.mfa-required.message2": "Du kommer att omdirigeras till dina kontoinställningar i Online Dashboard. Aktivera 2FA, följ installationsanvisningarna och återvänd sedan hit.",
    "error.mfa-required.learnMore": "Läs mer om 2FA",
    "error.mfa-required.continue": "Fortsätt",
    "error.root-admin-login.title": "Fel 403- förbjudet",
    "error.root-admin-login.message": "Du är inloggad som skrivskyddad administratör. För att få åtkomst till Web Recovery-konsolen loggar du istället in som kundklient-användare eller administratör",
    "error.server-busy.message": "Servern är upptagen, försök igen senare.",
    "error.network-connection.title": "Nätverksanslutningsfel",
    "error.network-connection.message": "Kontrollera internetanslutningen och försök igen.",
    "error.internal-server-error.title": "Internt serverfel",
    "error.internal-server-error.message": "För att lösa felet, kontakta support med feldetaljerna:",
    "error.internal-server-error.copy.button": "Kopiera"
};
